if (document.body.classList.contains("home")) {
    const video = document.querySelector(".mv__innerBlockVid video");
    const btn = document.querySelector(".mv__innerBlockVidBtn");

    btn.addEventListener("click", () => {
        if (video.paused) {
            video.play();
            btn.classList.remove("is-stopping");
        } else {
            video.pause();
            btn.classList.add("is-stopping");
        }
    });

    const swiperWrapper = document.querySelector(
        ".pickup__innerSwiper .swiper"
    );
    const hides = [
        document.querySelector(".pickup__innerSwiper .swiper .hideLeft"),
        document.querySelector(".pickup__innerSwiper .swiper .hideRight"),
    ];

    const resize = () => {
        const pad = swiperWrapper.getBoundingClientRect().left;

        hides[0].style.translate = `-${pad}px 0 `;
        hides[0].style.width = `${pad}px`;
        hides[1].style.translate = `${pad}px 0 `;
        hides[1].style.width = `${pad}px`;
    };

    resize();
    let resizeTimeout;

    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(resize, 350);
    });
}
